﻿import { SearchController } from "./search/search.controller";
import { SearchGateway } from './search/search.gateway';
import { EventLogController } from "./eventLog/eventLog.controller";
import { EventLogDetailController } from "./eventLog/eventLogDetail.controller";
import { EventLogGateway } from './eventLog/eventLog.gateway';
import { RatingFactorsController } from './ratingFactors/ratingFactors.controller';
import { RatingFactorsGateway } from './ratingFactors/ratingFactors.gateway';
import { PaymentMethodSearchController } from './payments/paymentMethodSearch.controller';
import { PaymentMethodSearchGateway } from './payments/paymentMethodSearch.gateway';
import { PaymentSearchController } from './payments/paymentSearch.controller';
import { PaymentSearchGateway } from './payments/paymentSearch.gateway';
import { PaymentSearchByStatementController } from './payments/paymentSearchByStatement.controller';
import { PaymentSearchByStatementGateway } from './payments/paymentSearchByStatement.gateway';
import { AdminPaymentController } from "./payments/adminPayment.controller";
import { AdminPaymentGateway } from "./payments/adminPayment.gateway";
import { PaymentMethodEditController } from "./payments/paymentMethodEdit.controller";
import { PaymentMethodEditGateway } from "./payments/paymentMethodEdit.gateway";
import { PaymentAccountTypeService } from "./payments/paymentAccountType.service";
import { ClientStateContextRepository } from "../quoteWizard/repositories/clientStateContext.repository";
import { ClientStateContextSearchGateway } from "./clientSuccess/clientstatecontextSearch.gateway";
import { ClientStateContextSearchController } from "./clientSuccess/clientstatecontextSearch.controller";
import { ClientStateContextSearchDetailGateway } from "./clientSuccess/clientstatecontextSearchDetail.gateway";
import { ClientStateContextSearchDetailController } from "./clientSuccess/clientstatecontextSearchDetail.controller";
import { Roles } from "../models/constants/authentication.constants";
import { AdminPaymentReceiptController } from "./payments/adminPaymentReceipt.controller";


export default angular.module('idi.marketplace.administration', ['core',
    "ui.grid",
    "ui.grid.edit",
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'angular-clipboard'])
    .controller("search.controller", SearchController)
    .service('search.gateway', SearchGateway)
    .controller("eventLog.controller", EventLogController)
    .controller("eventLogDetail.controller", EventLogDetailController)
    .service('eventLog.gateway', EventLogGateway)
    .controller('ratingFactors.controller', RatingFactorsController)
    .service('ratingFactors.gateway', RatingFactorsGateway)
    .controller('paymentMethodSearch.controller', PaymentMethodSearchController)
    .service('paymentMethodSearch.gateway', PaymentMethodSearchGateway)
    .controller('adminPayment.controller', AdminPaymentController)
    .service('adminPayment.gateway', AdminPaymentGateway)
    .service('paymentAccountType.service', PaymentAccountTypeService)
    .controller("adminPaymentReceipt.controller", AdminPaymentReceiptController)
    .controller('paymentMethodEdit.controller', PaymentMethodEditController)
    .service('paymentMethodEdit.gateway', PaymentMethodEditGateway)
    .controller('paymentSearch.controller', PaymentSearchController)
    .service('paymentSearch.gateway', PaymentSearchGateway)
    .controller('paymentSearchByStatement.controller', PaymentSearchByStatementController)
    .service('paymentSearchByStatement.gateway', PaymentSearchByStatementGateway)
    .service('clientStateContextRepository', ClientStateContextRepository)
    .service('clientStateContextSearch.gateway', ClientStateContextSearchGateway)
    .controller("clientStateContextSearch.controller", ClientStateContextSearchController)
    .service('clientStateContextSearchDetail.gateway', ClientStateContextSearchDetailGateway)
    .controller("clientStateContextSearchDetail.controller", ClientStateContextSearchDetailController)
    .config(routeConfig)
    .run(moduleRun)
    .name;

routeConfig.$inject = ['$stateProvider', '$locationProvider'];

function routeConfig($stateProvider: ng.ui.IStateProvider, $locationProvider:any): void {

    const defaultLoginRoute = 'shellFrame.authenticationFrame.login';

    $stateProvider
        .state('shellFrame.administrationFrame.search',
            {
                url: '/search',
                templateUrl: 'modules/administration/search/search.view.html',
                controller: 'search.controller',
                controllerAs: 'vm',
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn:defaultLoginRoute
                },
                resolve: {}
            })
        .state('shellFrame.administrationFrame.quickEdit',
            {
                url: '/quickedit/{submissionId}',
                templateUrl: '/modules/administration/ratingFactors/ratingFactors.view.html',
                controller: 'ratingFactors.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
        .state('shellFrame.administrationFrame.paymentMethodSearch',
            {
                url: '/paymentmethodsearch',
                templateUrl: '/modules/administration/payments/paymentMethodSearch.view.html',
                controller: 'paymentMethodSearch.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
        .state('shellFrame.administrationFrame.adminPayment',
            {
                url: '/adminpayment/{policyholderid}',
                templateUrl: '/modules/administration/payments/adminpayment.view.html',
                controller: 'adminPayment.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
            .state('shellFrame.administrationFrame.adminPaymentReceipt',
            {
                url: '/adminpaymentreceipt',
                params: { decisionType: null, reasonCode: null, merchantReferenceCode: null, requestId: null },
                templateUrl: '/modules/administration/payments/adminPaymentReceipt.view.html',
                controller: 'adminPaymentReceipt.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
            .state('shellFrame.administrationFrame.paymentMethodEdit',
            {
                url: '/paymentmethodedit/{policyholderid}',
                templateUrl: '/modules/administration/payments/paymentMethodEdit.view.html',
                controller: 'paymentMethodEdit.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
        .state('shellFrame.administrationFrame.eventLog',
            {
                url: '/eventLog',
                templateUrl: 'modules/administration/eventLog/eventLog.view.html',
                controller: 'eventLog.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
        .state('shellFrame.administrationFrame.eventLogDetail',
            {
                url: '/eventLogDetail/{eventLogId}',
                templateUrl: '/modules/administration/eventLog/eventLogDetail.view.html',
                controller: 'eventLogDetail.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
        .state('shellFrame.administrationFrame.paymentSearch',
            {
                url: 'paymentsearch/',
                templateUrl: '/modules/administration/payments/paymentSearch.view.html',
                controller: 'paymentSearch.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: "shellFrame.administrationFrame"
                }
            })
        .state('shellFrame.administrationFrame.paymentSearchByStatement',
            {
                url: 'paymentsearchbystatement/',
                templateUrl: '/modules/administration/payments/paymentSearchByStatement.view.html',
                controller: 'paymentSearchByStatement.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: "shellFrame.administrationFrame"
                }
            })

        .state('shellFrame.administrationFrame.clientstatecontextsearch',
            {
                url: '/clientstatecontextsearch',
                templateUrl: '/modules/administration/clientSuccess/clientstatecontextSearch.view.html',
                controller: 'clientStateContextSearch.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            })
        .state('shellFrame.administrationFrame.clientstatecontextsearchdetail',
            {
                url: '/clientstatecontextsearchdetail/{clientStateContextId}',
                templateUrl: '/modules/administration/clientSuccess/clientstatecontextSearchDetail.view.html',
                controller: 'clientStateContextSearchDetail.controller',
                controllerAs: 'vm',
                resolve: {},
                data: {
                    claimsProfile: { allowAnonymousAccess: false, claims: [Roles.Employee] },
                    redirectToSignOn: defaultLoginRoute
                }
            });
    $locationProvider.html5Mode(true);
}

moduleRun.$inject = ['$rootScope', '$document'];

function moduleRun($rootScope: angular.IRootScopeService, $document: angular.IDocumentService): void {
    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => {

        if (toState.name.indexOf("shellFrame.administrationFrame") > -1 || toState.name.indexOf("shellFrame.accountFrame") > -1) {
            $document.find("link[id='marketplaceStyles']").prop('disabled', true);
        } else {
            $document.find("link[id='marketplaceStyles']").prop('disabled', false);
        }
    });
}